import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconEyeOff = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 21.906'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M2.718,21.603 C2.523,21.798 2.267,21.895 2.011,21.895 C1.755,21.895 1.499,21.798 1.304,21.603 C0.913,21.215 0.913,20.584 1.304,20.195 L4.385,17.126 C1.116,15.035 -0.000,12.142 -0.000,10.939 C-0.000,8.338 4.205,1.976 12.000,1.976 C15.002,1.976 16.895,2.883 17.942,3.624 L21.304,0.276 C21.694,-0.113 22.327,-0.113 22.718,0.276 C23.108,0.665 23.108,1.296 22.718,1.684 L2.718,21.603 ZM9.312,12.219 L13.291,8.256 C12.890,8.065 12.453,7.952 12.000,7.952 C10.346,7.952 9.000,9.293 9.000,10.940 C9.000,11.388 9.121,11.819 9.312,12.219 ZM12.000,3.968 C5.216,3.968 2.000,9.560 2.000,10.939 C2.000,11.383 2.714,13.858 5.843,15.673 L7.881,13.644 C7.811,13.579 7.729,13.531 7.678,13.445 C7.234,12.688 7.000,11.822 7.000,10.940 C7.000,8.195 9.243,5.961 12.000,5.961 C12.989,5.961 13.940,6.262 14.753,6.800 L16.495,5.065 C15.670,4.557 14.243,3.968 12.000,3.968 ZM11.999,15.918 C11.477,15.918 11.037,15.515 11.002,14.988 C10.966,14.439 11.383,13.965 11.935,13.929 C13.576,13.822 14.895,12.509 15.002,10.874 C15.038,10.326 15.528,9.908 16.065,9.946 C16.616,9.981 17.034,10.455 16.998,11.004 C16.826,13.632 14.705,15.744 12.065,15.917 C12.043,15.918 12.021,15.918 11.999,15.918 ZM9.241,17.581 C10.113,17.799 11.042,17.910 12.000,17.910 C18.784,17.910 22.000,12.319 22.000,10.939 C22.000,10.523 21.567,9.170 20.228,7.647 C19.864,7.232 19.906,6.603 20.322,6.241 C20.737,5.879 21.369,5.921 21.733,6.335 C23.110,7.901 24.000,9.709 24.000,10.939 C24.000,13.540 19.795,19.902 12.000,19.902 C10.877,19.902 9.784,19.771 8.752,19.512 C8.216,19.378 7.892,18.836 8.026,18.303 C8.161,17.769 8.704,17.446 9.241,17.581 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconEyeOff.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
